export var BuildPresetType;
(function (BuildPresetType) {
    BuildPresetType["BALLERINA"] = "Ballerina";
    BuildPresetType["DOCKERFILE"] = "Dockerfile";
    BuildPresetType["MICRO_INTEGRATION"] = "WSO2 MI";
    BuildPresetType["WEB_APP_REACT"] = "React";
    BuildPresetType["WEB_APP_ANGULAR"] = "Angular";
    BuildPresetType["WEB_APP_VUEJS"] = "Vuejs";
    BuildPresetType["WEB_APP_STATIC_FILES"] = "StaticFiles";
    BuildPresetType["BYOI"] = "BYOI";
    BuildPresetType["TEST_RUNNER_POSTMAN"] = "Postman";
    BuildPresetType["BUILDPACK"] = "Buildpack";
    BuildPresetType["PRISM_MOCK"] = "PrismMock";
})(BuildPresetType || (BuildPresetType = {}));
export var ComponentTemplateType;
(function (ComponentTemplateType) {
    ComponentTemplateType["HttpApi"] = "httpApi";
    ComponentTemplateType["HttpProxyApi"] = "httpProxyApi";
    ComponentTemplateType["ManualTrigger"] = "manualTrigger";
    ComponentTemplateType["ScheduleTask"] = "scheduleTask";
    ComponentTemplateType["GraphqlApi"] = "graphqlApi";
    ComponentTemplateType["GraphqlProxyApi"] = "graphqlProxyApi";
    ComponentTemplateType["WebSocket"] = "webSocket";
    ComponentTemplateType["WebSocketProxy"] = "webSocketProxy";
    ComponentTemplateType["Webhook"] = "webhook";
    ComponentTemplateType["GrpcApi"] = "grpcApi";
    ComponentTemplateType["CustomApp"] = "customApp";
    ComponentTemplateType["ByoContainer"] = "byoContainer";
    ComponentTemplateType["GraphQL"] = "graphql";
    ComponentTemplateType["ThirdPartyApi"] = "thirdPartyApi";
    ComponentTemplateType["Microservices"] = "microservices";
    ComponentTemplateType["WebApp"] = "webApp";
    ComponentTemplateType["IntegrationApi"] = "IntegrationApi";
    ComponentTemplateType["IntegrationWebhook"] = "IntegrationWebhook";
    ComponentTemplateType["IntegrationScheduledTask"] = "IntegrationScheduledTask";
    ComponentTemplateType["IntegrationManualTriggers"] = "IntegrationManualTriggers";
    ComponentTemplateType["TestRunnerComponent"] = "testRunnerComponent";
    ComponentTemplateType["ExternalConsumer"] = "externalConsumer";
    ComponentTemplateType["PrismMockServiceComponent"] = "prismMockService";
    ComponentTemplateType["MCPServer"] = "mcpService";
    ComponentTemplateType["Database"] = "database";
})(ComponentTemplateType || (ComponentTemplateType = {}));
export var ComponentDisplayName;
(function (ComponentDisplayName) {
    ComponentDisplayName["MICROSERVICE"] = "Service";
    ComponentDisplayName["SCHEDULED_TRIGGER"] = "Scheduled Trigger";
    ComponentDisplayName["SCHEDULED_TASK"] = "Scheduled Task";
    ComponentDisplayName["MANUAL_TRIGGER"] = "Manual Trigger";
    ComponentDisplayName["MANUAL_TASK"] = "Manual Task";
    ComponentDisplayName["HTTP_PROXY"] = "REST API Proxy";
    ComponentDisplayName["WEBHOOK"] = "Webhook";
    ComponentDisplayName["INTEGRATION_AS_AN_API"] = "Integration as an API";
    ComponentDisplayName["INTEGRATION_WEBHOOK"] = "Event Handler";
    ComponentDisplayName["INTEGRATION_MANUAL_TRIGGER"] = "Manually-Triggered Integration";
    ComponentDisplayName["INTEGRATION_SCHEDULED_TRIGGER"] = "Scheduled Integration";
    ComponentDisplayName["THIRD_PARTY_API"] = "External REST API";
    ComponentDisplayName["WEB_APP"] = "Web Application";
    ComponentDisplayName["TEST_RUNNER"] = "Test Runner";
    ComponentDisplayName["EXTERNAL_CONSUMER"] = "External Consumer";
    ComponentDisplayName["MCP_SERVER"] = "MCP Server";
    ComponentDisplayName["DATABASE"] = "Database";
})(ComponentDisplayName || (ComponentDisplayName = {}));
export var ComponentDisplayType;
(function (ComponentDisplayType) {
    ComponentDisplayType["RestApi"] = "restAPI";
    ComponentDisplayType["ManualTrigger"] = "manualTrigger";
    ComponentDisplayType["ScheduledTask"] = "scheduledTask";
    ComponentDisplayType["Webhook"] = "webhook";
    ComponentDisplayType["Websocket"] = "webSocket";
    ComponentDisplayType["Proxy"] = "proxy";
    ComponentDisplayType["GitProxy"] = "gitProxy";
    ComponentDisplayType["ByocCronjob"] = "byocCronjob";
    ComponentDisplayType["ByocJob"] = "byocJob";
    ComponentDisplayType["GraphQL"] = "graphql";
    ComponentDisplayType["ThirdPartyAPI"] = "thirdPartyAPI";
    ComponentDisplayType["ByocWebApp"] = "byocWebApp";
    ComponentDisplayType["ByocWebAppDockerLess"] = "byocWebAppsDockerfileLess";
    ComponentDisplayType["ByocRestApi"] = "byocRestApi";
    ComponentDisplayType["ByocEventHandler"] = "byocEventHandler";
    ComponentDisplayType["MiRestApi"] = "miRestApi";
    ComponentDisplayType["MiEventHandler"] = "miEventHandler";
    ComponentDisplayType["Service"] = "ballerinaService";
    ComponentDisplayType["ByocService"] = "byocService";
    ComponentDisplayType["ByocWebhook"] = "byocWebhook";
    ComponentDisplayType["MiApiService"] = "miApiService";
    ComponentDisplayType["MiCronjob"] = "miCronjob";
    ComponentDisplayType["MiJob"] = "miJob";
    ComponentDisplayType["MiWebhook"] = "miWebhook";
    ComponentDisplayType["ByoiService"] = "byoiService";
    ComponentDisplayType["ByoiJob"] = "byoiJob";
    ComponentDisplayType["ByoiCronjob"] = "byoiCronjob";
    ComponentDisplayType["ByoiWebApp"] = "byoiWebApp";
    ComponentDisplayType["ByocTestRunner"] = "byocTestRunner";
    ComponentDisplayType["BuildpackService"] = "buildpackService";
    ComponentDisplayType["BuildpackEventHandler"] = "buildpackEventHandler";
    ComponentDisplayType["BuildpackJob"] = "buildpackJob";
    ComponentDisplayType["BuildpackTestRunner"] = "buildpackTestRunner";
    ComponentDisplayType["BuildpackCronJob"] = "buildpackCronjob";
    ComponentDisplayType["BuildpackWebApp"] = "buildpackWebApp";
    ComponentDisplayType["BuildpackWebhook"] = "buildpackWebhook";
    ComponentDisplayType["BuildRestApi"] = "buildpackRestApi";
    ComponentDisplayType["PostmanTestRunner"] = "byocTestRunnerDockerfileLess";
    ComponentDisplayType["BallerinaEventHandler"] = "ballerinaEventHandler";
    ComponentDisplayType["BallerinaWebhook"] = "ballerinaWebhook";
    ComponentDisplayType["ExternalConsumer"] = "externalConsumer";
    ComponentDisplayType["PrismMockService"] = "prismMockService";
    ComponentDisplayType["MCPServer"] = "mcpService";
    ComponentDisplayType["Database"] = "database";
})(ComponentDisplayType || (ComponentDisplayType = {}));
export var ApiAccessMode;
(function (ApiAccessMode) {
    ApiAccessMode["External"] = "external";
    ApiAccessMode["Internal"] = "internal";
})(ApiAccessMode || (ApiAccessMode = {}));
export var ComponentCreationStatus;
(function (ComponentCreationStatus) {
    ComponentCreationStatus["QUEUED"] = "queued";
    ComponentCreationStatus["IN_PROGRESS"] = "in_progress";
    ComponentCreationStatus["COMPLETED"] = "completed";
    ComponentCreationStatus["FAILURE"] = "failure";
})(ComponentCreationStatus || (ComponentCreationStatus = {}));
export var BuildPackLanguage;
(function (BuildPackLanguage) {
    BuildPackLanguage["Ballerina"] = "ballerina";
    BuildPackLanguage["Java"] = "java";
    BuildPackLanguage["Go"] = "go";
    BuildPackLanguage["NodeJs"] = "nodejs";
    BuildPackLanguage["Python"] = "python";
    BuildPackLanguage["Ruby"] = "ruby";
    BuildPackLanguage["Rust"] = "rust";
    BuildPackLanguage["Other"] = "other";
})(BuildPackLanguage || (BuildPackLanguage = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["SERVICE"] = "service";
    ComponentType["WEB_APP"] = "web-app";
    ComponentType["SCHEDULED_TASK"] = "scheduled-task";
    ComponentType["MANUAL_TASK"] = "manual-task";
    ComponentType["API_PROXY"] = "api-proxy";
    ComponentType["WEB_HOOK"] = "web-hook";
    ComponentType["EVENT_HANDLER"] = "event-handler";
    ComponentType["TEST"] = "test";
    ComponentType["EXTERNAL_CONSUMER"] = "external-consumer";
    ComponentType["SYSTEM_COMPONENT"] = "system";
})(ComponentType || (ComponentType = {}));
export var ServiceType;
(function (ServiceType) {
    ServiceType["HTTP"] = "HTTP";
    ServiceType["GRPC"] = "GRPC";
    ServiceType["WEBSOCKET"] = "Websocket";
    ServiceType["GRAPHQL"] = "GraphQL";
    ServiceType["WEBHOOK"] = "Webhook";
    ServiceType["WEBAPP"] = "WebApp";
    ServiceType["OTHER"] = "other";
})(ServiceType || (ServiceType = {}));
export var NetworkVisibilityType;
(function (NetworkVisibilityType) {
    NetworkVisibilityType["Project"] = "Project";
    NetworkVisibilityType["Organization"] = "Organization";
    NetworkVisibilityType["Public"] = "Public";
})(NetworkVisibilityType || (NetworkVisibilityType = {}));
